// authService.ts - Authentication API Calls
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axiosInstance from '@/config/axios.config';
import { deleteToken } from '@/utils';
export var somethingWentWrong = {
    data: null,
    error_info: 'Something Went Wrong',
    message: 'Something Went Wrong',
    status: 'error',
};
export var userLogin = function (email, password, user_type_id, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || '/user/login', {
                        type: 'manual',
                        identifier: email,
                        password: password,
                        token_lifetime: 1,
                        entity_type: 'user',
                        user_type_id: user_type_id,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_1 = _b.sent();
                return [2 /*return*/, ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var userSignup = function (payload, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || '/user/signup', __assign({ type: 'manual' }, payload))];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_2 = _b.sent();
                console.error('Signup failed:', error_2);
                return [2 /*return*/, ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var passwordResetRequest = function (email) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post('/user/forgot-password-reset-request', {
                        identifier: email,
                        entity_type: 'user',
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_3 = _b.sent();
                console.error('passwordResetRequest failed:', error_3);
                return [2 /*return*/, ((_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updatePassword = function (token, user_id, new_password, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                console.log(route, 'route...');
                return [4 /*yield*/, axiosInstance.post(route || '/user/forgot-password-update-password', {
                        token: token,
                        user_id: user_id,
                        new_password: new_password,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_4 = _b.sent();
                console.error('updatePassword failed:', error_4);
                return [2 /*return*/, ((_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUser = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_5;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.get("/user/".concat(id))];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_5 = _b.sent();
                console.error('updatePassword failed:', error_5);
                return [2 /*return*/, ((_a = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
// Validate Token API
export var validateToken = function (accessToken, route) { return __awaiter(void 0, void 0, Promise, function () {
    var config, response, error_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                console.log(route, 'route');
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                config = {};
                if (accessToken) {
                    config['headers'] = {
                        Authorization: "Bearer ".concat(accessToken),
                    };
                }
                return [4 /*yield*/, axiosInstance.get(route || '/user/validate-token', config)];
            case 2:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 3:
                error_6 = _b.sent();
                console.error('Token validation failed:', error_6);
                return [2 /*return*/, ((_a = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var sendOtpWrapper = function (email, user_id, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_7;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || '/user/send-verify-email-otp', {
                        email: email,
                        user_id: user_id,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                error_7 = _b.sent();
                console.error('Verify email Request failed:', error_7);
                return [2 /*return*/, ((_a = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var verifyOtpWrapper = function (user_id, otp, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_8;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || '/user/verify-email', {
                        user_id: user_id,
                        otp: otp,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_8 = _b.sent();
                console.error('Verify email failed:', error_8);
                return [2 /*return*/, ((_a = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var sendPasswordOtpWrapper = function (email, user_id, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_9;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || 'user/forgot-password-send-mail', {
                        email: email,
                        user_id: user_id,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                error_9 = _b.sent();
                console.error('Verify email Request failed:', error_9);
                return [2 /*return*/, ((_a = error_9 === null || error_9 === void 0 ? void 0 : error_9.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var verifyPasswordOtpWrapper = function (user_id, otp, route) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_10;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.post(route || '/user/forgot-password-verify-token', {
                        user_id: user_id,
                        otp: otp,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_10 = _b.sent();
                console.error('Verify email failed:', error_10);
                return [2 /*return*/, ((_a = error_10 === null || error_10 === void 0 ? void 0 : error_10.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUserType = function (config) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_11;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosInstance.get("/user-type", config)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_11 = _b.sent();
                console.error('updatePassword failed:', error_11);
                return [2 /*return*/, ((_a = error_11 === null || error_11 === void 0 ? void 0 : error_11.response) === null || _a === void 0 ? void 0 : _a.data) || somethingWentWrong];
            case 3: return [2 /*return*/];
        }
    });
}); };
// Logout API
export var userLogout = function () { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post('/auth/logout', {}, { withCredentials: true })];
            case 1:
                _a.sent();
                deleteToken();
                return [2 /*return*/];
        }
    });
}); };
